import { router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

export type PaginationMeta = {
  page: number
  per_page: number
  total: number
  total_pages: number
}

type PaginationProps = {
  pagination: PaginationMeta
}

export function Pagination({ pagination }: PaginationProps) {
  if (pagination.total_pages <= 1) return null

  const navigate = (page: number) => {
    const url = new URL(window.location.href)
    if (page > 1) {
      url.searchParams.set('page', String(page))
    } else {
      url.searchParams.delete('page')
    }
    router.get(url.pathname + url.search, {}, {
      preserveState: true,
      preserveScroll: true,
      replace: true,
    })
  }

  const from = (pagination.page - 1) * pagination.per_page + 1
  const to = Math.min(pagination.page * pagination.per_page, pagination.total)

  return (
    <div className="flex items-center justify-between pt-3">
      <span className="text-[12px] text-muted-foreground">
        {from}–{to} of {pagination.total}
      </span>
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          disabled={pagination.page <= 1}
          onClick={() => navigate(pagination.page - 1)}
        >
          <ChevronLeft className="h-3.5 w-3.5" />
        </Button>
        <span className="text-[12px] text-muted-foreground px-2">
          {pagination.page} / {pagination.total_pages}
        </span>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          disabled={pagination.page >= pagination.total_pages}
          onClick={() => navigate(pagination.page + 1)}
        >
          <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  )
}
